export enum NavigationMenuEnum {
  PoolSettings = 'header.menu.pool-settings',
  Finance = 'header.menu.finance',
  Users = 'header.menu.users',
  Roles = 'header.menu.roles',
  SystemNotifications = 'header.menu.system-notifications',
}
